const colors = {
	primary: "#00437a",
	gray: "#5e5e5e",
	pdfBackground: "white",
	previewBackground: "#333638",
};

const fontSizes = {
	small: 16,
	default: 16,
	large: 30,
};

export default {
	colors,
	fontSizes,
	pdfSpacing: 24,
	pdfPadding: 48,
};
